import Vue from 'vue';

export default {
    async getAllStrings() {
        return (await Vue.http.get('/api/content/strings')).data;
    },
    async getAllLinks() {
        return (await Vue.http.get('/api/content/links')).data;
    }
};



// WEBPACK FOOTER //
// ./_common/services/content.service.js